/** Socket.IO event names for campaign participant threads (namespaced from DM rooms). */
export const CAMPAIGN_THREAD_SOCKET = {
    JOIN: 'campaignThread:join',
    LEAVE: 'campaignThread:leave',
    TYPING: 'campaignThread:typing',
    SEND: 'campaignThread:send',
    MARK_READ: 'campaignThread:markRead',

    MESSAGE_NEW: 'campaignThread:messageNew',
    MESSAGE_UPDATED: 'campaignThread:messageUpdated',
    MESSAGE_DELETED: 'campaignThread:messageDeleted',
    ATTACHMENT_PROCESSING: 'campaignThread:attachmentProcessing',
    UNREAD_UPDATED: 'campaignThread:unreadUpdated',
    ERROR: 'campaignThread:error',
} as const;
